export default {
  pt: {
    // Common
    phoneSupport: 'Apoio via Telefone',
    nationalLandline: 'Chamada para a rede fixa nacional',
    backoffice: 'Backoffice',
    customerArea: 'Área Cliente',
    login: 'Entrar',
    services: 'Serviços',
    stores: 'Lojas',
    contacts: 'Contactos',
    rental: 'Aluguer',
    onlineStore: 'Loja Online',
    blog: 'Blog',
    aboutUs: 'Sobre Nós',
    book: 'Reservar',
    getStarted: 'Começar Agora',
    directions: 'Como Chegar',
    allRights: 'Todos os direitos reservados.',
    learnMore: 'Saber Mais',
    callNow: 'Ligar Agora',
    // Equipment
    exploreEquipment: 'Quero Alugar!',
    featuredEquipment: 'Equipamentos em Destaque',
    exploreOur: 'Explore os nossos',
    availableEquipment: 'Equipamentos Disponíveis',
    ceCertified: 'Equipamentos certificados CE com a mais alta qualidade do mercado',
    viewAllEquipment: 'Ver Todos os Equipamentos',
    swipeMore: 'Deslize para ver mais',
    priceFrom: 'Desde',
    priceDay: 'dia',
    priceWeek: 'semana',
    priceMonth: 'mês',
    enquirePrice: 'Consultar preço',
    // Fast delivery
    fastDelivery: 'Entrega Rápida',
    deliveryH2: 'Equipamentos na Sua',
    deliveryH2Highlight: 'Casa em 2 Horas',
    deliveryDesc: 'Com mais de 5 anos de experiência, garantimos entregas ultra-rápidas no Distrito de Lisboa e em todo o país em 24-48h.',
    feature1: 'Montagem e desmontagem incluída',
    feature2: 'Equipamento certificado e higienizado',
    feature3: 'Equipa técnica especializada',
    feature4: 'Atendimento 24/7 disponível',
    // Stats
    satisfiedClients: 'Clientes Satisfeitos',
    availableEquipmentStat: 'Equipamentos Disponíveis',
    yearsExperience: 'Anos de Experiência',
    supportAvailable: 'Atendimento Disponível',
    // Services
    ourServices: 'Os Nossos Serviços',
    rentOrBuy: 'Alugar ou Comprar?',
    twoSolutions: 'Oferecemos duas soluções para que encontre a melhor opção para as suas necessidades',
    // Rental card
    rentalTitle: 'Aluguer',
    rentalDesc: 'Ideal para necessidades temporárias ou experimentar antes de comprar.',
    flexibility: 'Flexibilidade Total',
    flexibilityDesc: 'Alugue por dias, semanas ou meses',
    noCommitment: 'Sem Compromisso',
    noCommitmentDesc: 'Devolva quando não precisar mais',
    maintenanceIncluded: 'Manutenção Incluída',
    maintenanceIncludedDesc: 'Equipamento sempre em perfeito estado',
    fastDeliveryCard: 'Entrega Rápida',
    fastDeliveryCardDesc: '24-48h em todo o país. Lisboa no próprio dia',
    viewRental: 'Ver Equipamentos para Alugar',
    // Buy card
    buyTitle: 'Comprar',
    buyDesc: 'Perfeito para uso prolongado ou permanente.',
    yoursForever: 'É Seu para Sempre',
    yoursForeverDesc: 'Investimento a longo prazo',
    economical: 'Mais Económico',
    economicalDesc: 'Para necessidades permanentes',
    customization: 'Personalização Total',
    customizationDesc: 'Adapte ao seu gosto e necessidade',
    freeShipping: 'Portes Grátis +',
    freeShippingDesc: 'Entrega rápida em todo o país',
    visitStore: 'Visitar Loja Online',
    // Comparison
    quickComparison: 'Comparação Rápida',
    initialCost: 'Custo Inicial',
    low: 'Baixo',
    higher: 'Mais Elevado',
    maintenanceRow: 'Manutenção',
    included: 'Incluída',
    yourAccount: 'Por sua conta',
    flexibilityRow: 'Flexibilidade',
    maximum: 'Máxima',
    committed: 'Comprometido',
    idealFor: 'Ideal para',
    rentalIdeal: 'Recuperação, testes, curto prazo',
    buyIdeal: 'Uso permanente, condições crónicas',
    // Why choose us (Landing)
    whyChooseUs: 'Porque Escolher-nos',
    yearsOfService: 'Mais de 5 Anos ao Seu Serviço',
    feat1Title: 'Experiência', feat1Desc: '+5 anos no mercado com equipamento certificado CE',
    feat2Title: 'Entrega Express', feat2Desc: '2 horas no Distrito de Lisboa. 24-48h resto do país',
    feat3Title: 'Disponível 24h', feat3Desc: 'Atendimento por telefone e WhatsApp a qualquer hora',
    feat4Title: 'Qualidade', feat4Desc: 'Os melhores produtos ortopédicos e geriátricos',
    feat5Title: 'Atendimento', feat5Desc: 'Consultores especializados sempre disponíveis',
    feat6Title: 'Entregas Urgentes', feat6Desc: 'Montagem e desmontagem incluída',
    feat7Title: 'Stock', feat7Desc: 'Grande exposição para entrega imediata',
    feat8Title: 'Confiança', feat8Desc: 'Centenas de clientes satisfeitos',
    // Testimonials
    testimonials: 'Testemunhos',
    whatClientsSay: 'O Que Dizem os Nossos',
    clientsLabel: 'Clientes',
    clientSince: 'Cliente desde',
    testimonial1: 'Excelente serviço! A entrega foi rápida e o equipamento estava impecável. Recomendo!',
    testimonial2: 'Profissionais muito atenciosos e equipamento de qualidade superior. Voltarei com certeza.',
    testimonial3: 'Atendimento 24h fez toda a diferença. Precisei de ajuda de urgência e foram incríveis!',
    // Stores
    ourStores: 'As Nossas Lojas',
    visitUsLisbon: 'Visite-nos em Lisboa',
    twoStoresDesc: 'Duas lojas ao seu dispor com profissionais especializados',
    // CTA
    readyToStart: 'Pronto para Começar?',
    exploreOrVisit: 'Explore os nossos equipamentos ou visite a nossa loja online',
    viewRentalCTA: 'Ver Equipamentos para Alugar',
    buyOnline: 'Comprar na Loja Online',
    // FAQ
    faqBadge: 'Perguntas Frequentes',
    faqTitle: 'Tire as Suas',
    faqTitleHighlight: 'Dúvidas',
    faqDesc: 'Respostas às perguntas mais comuns sobre os nossos serviços',
    // Quote
    quoteBadge: 'Pedido de Orçamento',
    quoteTitle: 'Solicite um',
    quoteTitleHighlight: 'Orçamento Personalizado',
    quoteDesc: 'Preencha o formulário e receba uma proposta adaptada às suas necessidades',
    // Contact bar
    support24h: 'Atendimento 24 Horas',
    available24hDesc: 'Estamos disponíveis a qualquer hora do dia ou da noite',
    phone24h: 'Telefone 24h',
    whatsapp24h: 'WhatsApp 24h',
    messageLabel: 'Mensagem',
    // Reservas page
    rentalEquipment: 'Equipamentos para Aluguer',
    loadingEquipment: 'A carregar equipamentos...',
    noEquipmentFound: 'Nenhum equipamento encontrado.',
    availableBadge: 'Disponível',
    allCategories: 'Todos',
    perDay: 'Por Dia:',
    perWeek: 'Por Semana:',
    perMonth: 'Por Mês:',
    bookNow: 'Reservar Agora',
    simulate: 'Simular',
    details: 'Detalhes',
    seeAll: 'Ver Todos os Equipamentos',
    contactCenter: 'Central de Atendimento',
    hours24: '24 horas',
    // Features Reservas
    moreExperience: 'Mais Experiência',
    moreExperienceDesc: 'Estamos no mercado há mais de 5 anos, com equipamento certificado CE.',
    fastDeliveries: 'Entregas Rápidas',
    fastDeliveriesDesc: 'Entregamos em 24-48h em todo o país. Em Lisboa, entregas no próprio dia.',
    highQuality: 'Alta Qualidade',
    highQualityDesc: 'Selecionamos os melhores produtos ortopédicos e geriátricos.',
    professionalSupport: 'Atendimento Profissional',
    professionalSupportDesc: 'Consultores especializados para ajudar a encontrar a melhor solução.',
    ownTechTeam: 'Equipa Técnica Própria',
    ownTechTeamDesc: 'Equipa de transporte, montagem e manutenção dos equipamentos.',
    faster: 'Mais Rápidos',
    fasterDesc: 'Entregas no próprio dia ou em menos de 24 horas.',
    freeDemo: 'Demonstrações Gratuitas',
    freeDemoDesc: 'Demonstrações ao domicílio de cadeiras de rodas elétricas e scooters.',
    largestStock: 'Maior Stock',
    largestStockDesc: 'Grande exposição de produtos disponíveis para entrega imediata.',
    whyChooseTitle: 'Cuidar com Experiência',
    whyChooseSubtitle: 'Mais de 5 anos dedicados ao seu bem-estar',
    // Reviews
    whatClientsSayReservas: 'O que os Nossos Clientes',
    sayAboutUs: 'Dizem Sobre Nós',
    // Contact Reservas
    talkToUs: 'Fale Connosco',
    contactUsTitle: 'Entre em Contacto',
    hereToHelp: 'Estamos aqui para ajudar! Envie-nos a sua mensagem e responderemos rapidamente.',
    phoneLabel: 'Telefone',
    scheduleLabel: 'Horário',
    usefulLinks: 'Links Úteis',
    equipment: 'Equipamentos',
    customerAreaFooter: 'Área Cliente',
    loginRegister: 'Entrar / Registar',
    completeProfile: 'Complete o Seu Perfil',
    completeProfileDesc: 'Por favor, complete os seus dados antes de fazer uma reserva.',
    // AboutUs
    ourValuesTitle: 'Os Nossos Valores',
    ourValuesPrinciples: 'Princípios que guiam cada decisão e interação com os nossos clientes.',
    ourJourney: 'O Nosso Percurso',
    ourTeam: 'A Nossa Equipa',
    dedicatedPros: 'Profissionais dedicados ao seu bem-estar',
    visitUsTitle: 'Visite-nos',
    careTitle: 'Cuidado e Empatia',
    careDesc: 'Tratamos cada cliente como família, compreendendo as suas necessidades únicas de mobilidade e bem-estar.',
    qualityGuaranteedTitle: 'Qualidade Garantida',
    qualityGuaranteedDesc: 'Todo o nosso equipamento é certificado CE e passa por rigorosos processos de manutenção e higienização.',
    quickResponseTitle: 'Resposta Rápida',
    quickResponseDesc: 'Entregamos em 24-48 horas porque sabemos que a mobilidade não pode esperar.',
    commitmentTitle: 'Compromisso Total',
    commitmentDesc: 'Acompanhamos os nossos clientes desde a escolha do equipamento até à devolução.',
    salesTeam: 'Equipa Comercial',
    salesRole: 'Atendimento ao Cliente',
    salesDesc: 'Especialistas em ajudar a encontrar o equipamento ideal para cada situação.',
    techTeam: 'Equipa Técnica',
    techRole: 'Manutenção & Logística',
    techDesc: 'Responsáveis pela preparação, entrega e recolha de todo o equipamento.',
    supportTeam: 'Equipa de Apoio',
    supportRole: 'Suporte 24/7',
    supportDesc: 'Disponíveis para resolver qualquer questão a qualquer hora.',
    ctaTitle: 'Pronto para Começar?',
    ctaDesc: 'Explore os nossos equipamentos para aluguer ou visite a nossa loja online.',
    viewRentalAbout: 'Ver Equipamentos para Aluguer',
    visitOnlineStore: 'Visitar Loja Online',
    // Reservas hardcoded
    rentWord: 'Alugar',
    equipmentWord: 'Equipamento',
    rentCardDesc: 'Cadeiras de rodas, camas articuladas, andarilhos e muito mais.',
    buyWord: 'Comprar',
    productsWord: 'Produtos',
    buyCardDesc: 'Visite a nossa loja online ou faça a sua encomenda.',
    viewStoreBtn: 'Ver Loja',
    openingHours: 'Seg-Sex: 09h30-13h / 14h-18h30 | Sáb: 09h-13h',
    openingHoursJunqueira: 'Seg-Sex: 09h30-13h / 14h-18h30',
    heroBodyText: 'Equipamento ortopédico de qualidade para <strong>alugar</strong> ou <strong>comprar</strong>.<br/><strong>Atendimento 24 horas</strong> por telefone e WhatsApp. <strong>Entregas em 2 horas</strong> no Distrito de Lisboa.',
    lojaBenfica: 'Loja Benfica',
    lojaJunqueira: 'Loja Junqueira',
    storeNameBenfica: 'Loja Benfica',
    storeNameJunqueira: 'Loja Junqueira',
    getStartedNow: 'Começar Agora',
    // FAQ
    faqMainTitle: 'Perguntas',
    faqMainHighlight: 'Frequentes',
    faqMainDesc: 'Tudo o que precisa saber sobre aluguer de equipamento ortopédico em Portugal',
    faqNoAnswer: 'Não encontrou a resposta que procurava?',
    faqCallNow: 'Ligar Agora: 21 603 5281',
    faqSendEmail: 'Enviar Email',
    faqQ1: 'Como funciona o aluguer de equipamento ortopédico?',
    faqA1: 'O processo é simples e rápido: 1) Escolha o equipamento que precisa no nosso catálogo online, 2) Selecione o período de aluguer (dia, semana ou mês), 3) Faça a reserva online de forma segura, 4) Receba o equipamento certificado e higienizado em casa. Entregamos em toda Portugal em 24-48h.',
    faqQ2: 'Quanto custa alugar uma cadeira de rodas em Portugal?',
    faqA2: 'Os preços variam consoante o tipo de cadeira e o período escolhido. As cadeiras manuais começam a partir de valores muito acessíveis por dia, com descontos para períodos mais longos. Consulte o nosso catálogo para preços específicos. Todos os preços incluem equipamento certificado, higienizado e com manutenção garantida.',
    faqQ3: 'Fazem entregas em todo Portugal?',
    faqA3: 'Sim, fazemos entregas em todo o território nacional! Servimos Lisboa, Porto, Coimbra, Braga, Faro e todas as outras cidades. A entrega é rápida (24-48h) e inclui a instalação e explicação do funcionamento. Também fazemos a recolha no final do período de aluguer.',
    faqQ4: 'O equipamento ortopédico é certificado e seguro?',
    faqA4: 'Sim, 100%! Todo o nosso equipamento é certificado segundo as normas europeias. Cada item é profissionalmente higienizado e desinfetado entre utilizações, seguindo protocolos hospitalares rigorosos. Realizamos manutenção preventiva regular para garantir perfeito funcionamento.',
    faqQ5: 'Posso prolongar o período de aluguer?',
    faqA5: 'Sim, pode prolongar o aluguer a qualquer momento! Basta contactar-nos por telefone, email ou através da sua área de cliente antes do fim do período inicial. Oferecemos total flexibilidade para se adaptar à sua recuperação.',
    faqQ6: 'Que tipos de equipamento ortopédico têm disponível?',
    faqA6: 'Temos: cadeiras de rodas manuais e elétricas, camas articuladas elétricas e manuais, andarilhos, canadianas, cadeiras de banho, elevadores de transferência, rampas de acesso, almofadas anti-escaras, colchões ortopédicos, e muito mais.',
    faqQ7: 'É necessário pagar caução no aluguer?',
    faqA7: 'Depende do tipo de equipamento. Alguns produtos de maior valor requerem uma caução de segurança, totalmente devolvida no final do aluguer desde que o equipamento seja devolvido em bom estado. Informamos sempre o valor antes de confirmar a reserva.',
    faqQ8: 'Como é feita a devolução do equipamento?',
    faqA8: 'A devolução é muito simples! Recolhemos o equipamento diretamente na sua morada, ou pode devolver numa das nossas lojas. Agendamos previamente a data e hora de recolha que melhor lhe convier. Não precisa de embalar nada - tratamos de tudo.',
    faqQ9: 'Dão formação sobre como usar o equipamento?',
    faqA9: 'Sim, absolutamente! Na entrega, o nosso técnico faz uma demonstração completa do funcionamento, tira todas as suas dúvidas e deixa instruções por escrito. Também disponibilizamos apoio telefónico durante todo o período de aluguer.',
    faqQ10: 'Posso alugar equipamento para um familiar ou amigo?',
    faqA10: 'Sim, pode fazer o aluguer em nome de outra pessoa! Basta indicar os dados da pessoa e a morada de entrega durante a reserva. Facilitamos todo o processo para que possa ajudar quem precisa.',
    faqQ11: 'Quanto tempo demora a entrega do equipamento?',
    faqA11: 'Para a Grande Lisboa e Grande Porto, conseguimos entregas no próprio dia ou no dia seguinte. Para o resto de Portugal, a entrega é feita em 24-48h após confirmação do pagamento. Em situações urgentes, contacte-nos.',
    faqQ12: 'Que métodos de pagamento aceitam?',
    faqA12: 'Aceitamos: cartão de crédito/débito (Visa, Mastercard), Multibanco, MBWay, e transferência bancária. O pagamento é totalmente seguro. Para alugueres de longa duração, também oferecemos opções de pagamento faseado.',
    faqCatProcess: 'Processo',
    faqCatPrices: 'Preços',
    faqCatDelivery: 'Entregas',
    faqCatQuality: 'Qualidade',
    faqCatFlex: 'Flexibilidade',
    faqCatCatalog: 'Catálogo',
    faqCatPayment: 'Pagamento',
    faqCatReturn: 'Devolução',
    faqCatSupport: 'Suporte',
    // ContactForm
    contactFormTitle: 'Envie-nos uma Mensagem',
    contactFormSubtitle: 'Preencha o formulário e entraremos em contacto nas próximas 24 horas',
    contactFormNameLabel: 'Nome Completo',
    contactFormEmailLabel: 'Email',
    contactFormPhoneLabel: 'Telefone',
    contactFormMessageLabel: 'Mensagem',
    contactFormNamePlaceholder: 'Ex: João Silva',
    contactFormEmailPlaceholder: 'Ex: joao.silva@email.com',
    contactFormPhonePlaceholder: 'Ex: 912345678',
    contactFormMessagePlaceholder: 'Descreva o que precisa: tipo de equipamento, período de aluguer, localização, etc.',
    contactFormSending: 'A Enviar...',
    contactFormSendBtn: 'Enviar Mensagem',
    contactFormSuccessTitle: 'Mensagem Enviada com Sucesso!',
    contactFormSuccessDesc: 'Recebemos a sua mensagem e iremos responder em breve.',
    contactFormSuccessEmail: 'Enviámos também um email de confirmação para',
    contactFormNewMsg: 'Enviar Nova Mensagem',
    contactFormRequired: '* Campos obrigatórios. Os seus dados serão tratados de forma confidencial.',
    contactFormErrorSend: 'Erro ao enviar mensagem. Por favor, tente novamente ou contacte-nos diretamente.',
    contactFormErrNameReq: 'Nome é obrigatório',
    contactFormErrNameMin: 'Nome deve ter pelo menos 3 caracteres',
    contactFormErrEmailReq: 'Email é obrigatório',
    contactFormErrEmailInvalid: 'Email inválido',
    contactFormErrPhoneReq: 'Telefone é obrigatório',
    contactFormErrPhoneInvalid: 'Telefone inválido (ex: 912345678 ou +351912345678)',
    contactFormErrMsgReq: 'Mensagem é obrigatória',
    contactFormErrMsgMin: 'Mensagem deve ter pelo menos 10 caracteres',
    // QuoteRequestForm
    quoteFormNameLabel: 'Nome Completo',
    quoteFormPhoneLabel: 'Telefone',
    quoteFormEmailLabel: 'Email',
    quoteFormEquipmentLabel: 'Equipamento Pretendido',
    quoteFormMsgLabel: 'Mensagem / Detalhes do Pedido',
    quoteFormEquipmentPlaceholder: 'Ex: Cadeira de rodas, Scooter...',
    quoteFormMsgPlaceholder: 'Descreva as suas necessidades, período pretendido, localização, etc.',
    quoteFormSending: 'A Enviar...',
    quoteFormSubmit: 'Solicitar Orçamento Grátis',
    quoteFormSuccessTitle: 'Pedido Enviado com Sucesso!',
    quoteFormSuccessDesc: 'Entraremos em contacto consigo brevemente com o seu orçamento personalizado.',
    quoteFormSendAnother: 'Enviar Outro Pedido',
    quoteFormFooter: 'Responderemos em menos de 24 horas. Atendimento personalizado garantido.',
    quoteFormNamePlaceholder: 'O seu nome',
    // Reservas page settings defaults
    reservasHeroTitle: 'Aluguer Material Ortopédico',
    reservasHeroSubtitle: 'Equipamento ortopédico de qualidade para aluguer. Entrega ao domicílio em todo o país.',
    reservasHeroButton: 'Ver Equipamentos',
    reservasWelcomeTitle: 'Bem-vindo à',
    reservasWelcomeText: 'Somos a marca de quem cuida. Aqui, encontrará tudo o que precisa para melhorar a sua qualidade de vida ou a de quem mais ama. Desde produtos de apoio e mobilidade a serviços especializados, estamos ao seu lado para oferecer soluções personalizadas e inovadoras, que promovem conforto e segurança.',
    landingHeroSubtitle: 'A sua Ortopedia de Confiança em Lisboa',
    // Blog
    blogRental: 'Aluguer',
    blogStore: 'Loja',
    blogAboutUs: 'Sobre Nós',
    blogHeroDesc: 'Dicas, novidades e informações sobre mobilidade e equipamentos ortopédicos.',
    blogSearchPlaceholder: 'Pesquisar artigos...',
    blogAll: 'Todos',
    blogLoading: 'A carregar artigos...',
    blogEmpty: 'Nenhum artigo encontrado.',
    blogReadArticle: 'Ler Artigo',
    blogReadMore: 'Ler mais',
    blogNewsletterTitle: 'Mantenha-se Informado',
    blogNewsletterDesc: 'Visite o nosso blog regularmente para mais dicas e novidades sobre mobilidade.',
    blogViewEquipment: 'Ver Equipamentos',
    blogVisitStore: 'Visitar Loja',
    // Reviews
    reviewsTitle: 'O Que Dizem os Nossos',
    reviewsHighlight: 'Clientes',
    reviewsSubtitle: 'Avaliações verificadas de clientes em Portugal',
    reviewsLeaveBtn: 'Deixar Avaliação',
    reviewsCancel: 'Cancelar',
    reviewsVerified: 'Cliente Verificado',
    reviewsFormTitle: 'Deixe a Sua Avaliação',
    reviewsFormName: 'Nome',
    reviewsFormNamePlaceholder: 'O seu nome',
    reviewsFormEquipment: 'Equipamento Alugado',
    reviewsFormEquipmentPlaceholder: 'Ex: Cadeira de Rodas Manual',
    reviewsFormRating: 'Classificação',
    reviewsFormComment: 'Comentário',
    reviewsFormCommentPlaceholder: 'Partilhe a sua experiência com o aluguer de equipamento ortopédico...',
    reviewsFormSubmit: 'Publicar Avaliação',
    reviewsBasedOn: 'Baseado em',
    reviewsReview: 'avaliação',
    reviewsReviews: 'avaliações',
    // RentalSimulator
    simTitle: 'Simulador de Aluguer',
    simDesc: 'Simule o custo do aluguer de',
    simStep1: 'Simulação',
    simStep2: 'Contacto',
    simCountyLabel: 'Concelho de Entrega',
    simCountyPlaceholder: 'Selecione o concelho',
    simRentalMode: 'Modo de Aluguer *',
    simPerDay: 'Por Dia',
    simPerWeek: 'Por Semana',
    simPerMonth: 'Por Mês',
    simStartDate: 'Data de Início *',
    simEndDate: 'Data de Fim *',
    simDeliverySchedule: 'Horários de Entrega e Recolha',
    simDeliveryTime: 'Hora de Entrega',
    simPickupTime: 'Hora de Recolha',
    simExtraFeeWarning: 'Entregas/recolhas fora deste horário ou aos fins de semana têm taxa extra',
    simDeliveryType: 'Tipo de Entrega *',
    simStorePickup: 'Levantamento em Loja',
    simHomeDelivery: 'Entrega ao Domicílio',
    simOptionalExtras: 'Extras Opcionais',
    simCostSummary: 'Resumo de Custos',
    simRentalLabel: 'Aluguer',
    simPrep: 'Preparação',
    simDeliveryFee: 'Taxa de Entrega',
    simPickupFee: 'Taxa de Recolha',
    simExtrasLabel: 'Extras',
    simExtraFees: 'Taxas Extra',
    simSubtotal: 'Subtotal',
    simDeposit: '+ Caução (devolvível)',
    simTotal: 'TOTAL',
    simDepositNote: 'A caução será devolvida na íntegra após devolução do equipamento em bom estado.',
    simSendMethod: 'Método de Envio *',
    simFullName: 'Nome Completo *',
    simPhone: 'Telefone / WhatsApp *',
    simEmail: 'Email *',
    simOptMsg: 'Mensagem Adicional (Opcional)',
    simMsgPlaceholder: 'Deixe aqui alguma mensagem ou pedido especial...',
    simBack: 'Voltar',
    simCancel: 'Cancelar',
    simContinue: 'Continuar',
    simSending: 'A Enviar...',
    simSendProposal: 'Enviar Proposta',
    simProposalSent: '✅ Proposta Enviada!',
    simProposalDesc: 'Receberá a proposta profissional em breve',
    simProposalTeam: 'A nossa equipa entrará em contacto para confirmar a disponibilidade.',
    simSimComplete: 'Simulação completa! Escolha como quer receber a proposta profissional.',
    simDays: 'dias',
    simNote: 'Nota',
    simWarning: 'Esta é apenas uma simulação. A reserva só será confirmada após contacto da nossa equipa e verificação de disponibilidade.',
    simEmailBy: 'no seu email',
    simSmsBY: 'por SMS',
    simWhatsappBy: 'no WhatsApp',
    simWorkHours: 'Horário',
    simWorkDays: '(Seg-Sex)',
    // BookingModal
    bookTitle: 'Nova Reserva',
    bookCompleteProfile: 'Complete o Seu Perfil',
    bookStep1: 'Datas & Extras',
    bookStep2: 'Entrega',
    bookStep3: 'Confirmar',
    bookRentalMode: '1. Modo de Aluguer *',
    bookSelectMode: 'Selecione o modo primeiro',
    bookPerDay: 'Por Dia',
    bookPerWeek: 'Por Semana',
    bookPerMonth: 'Por Mês',
    bookStartDate: '2. Data de Início *',
    bookEndDate: '3. Data de Fim *',
    bookCancel: 'Cancelar',
    bookContinue: 'Continuar',
    bookBack: 'Voltar',
    bookConfirm: 'Confirmar Reserva',
    bookCreate: 'Criar Reserva',
    bookProcessing: 'A processar...',
    bookSaving: 'A guardar...',
    bookSaveAndContinue: 'Guardar e Continuar',
    bookDeliveryType: 'Tipo de Entrega *',
    bookStorePickup: 'Levantamento',
    bookStorePickupSub: 'em Loja',
    bookHomeDelivery: 'Entrega',
    bookHomeDeliverySub: 'ao Domicílio',
    bookReservationSummary: 'Resumo da Reserva',
    bookViewAvailability: '📅 Ver Disponibilidade',
    bookCalendarDesc: 'Calendário visual de datas disponíveis',
    bookShow: 'Mostrar',
    bookHide: 'Ocultar',
    bookMode: 'Modo',
    bookModeDaily: 'Diário',
    bookModeWeekly: 'Semanal',
    bookModeMonthly: 'Mensal',
    bookTotal: 'Total',
    bookEdit: 'Editar',
    bookIncompleteProfile: 'Perfil Incompleto',
    bookIncompleteDesc: 'Por favor, complete o seu perfil antes de fazer uma reserva.',
    bookMissingFields: 'Campos em falta',
    // BookingModal - Profile form
    bookPersonalData: 'Dados Pessoais Obrigatórios',
    bookFullName: 'Nome Completo *',
    bookPhoneField: 'Telefone *',
    bookEmailField: 'Email *',
    bookEmailNote: 'Email não pode ser alterado',
    bookFullAddress: 'Morada Completa *',
    bookDoorNumber: 'Nº Porta *',
    bookFloor: 'Andar (opcional)',
    bookPostalCode: 'Código Postal *',
    bookLocality: 'Localidade *',
    bookCountyField: 'Concelho *',
    bookNIF: 'NIF (opcional)',
    bookCC: 'Cartão de Cidadão (opcional)',
    // BookingModal - Step 2
    bookSelectStore: 'Selecionar Loja *',
    bookNoStores: 'Nenhuma loja disponível',
    bookPickupReturnTimes: 'Horários de Levantamento/Devolução',
    bookDeliveryReturnTimes: 'Horários de Entrega/Recolha',
    bookOutsideHoursFee: 'Se escolher horários fora do horário da loja, poderá ser aplicada taxa extra',
    bookPickupHour: 'Hora Levantamento',
    bookReturnHour: 'Hora Devolução',
    bookDeliveryHour: 'Entrega',
    bookPickupHourLabel: 'Recolha',
    bookDeliveryAddressLabel: 'Morada de Entrega',
    bookProfileAddress: 'Morada do perfil',
    bookDifferentAddress: 'Morada diferente',
    bookProfileAddressTitle: 'Morada do Perfil',
    // BookingModal - Step 3 summary
    bookEquipmentLabel: 'Equipamento:',
    bookPeriodLabel: 'Período:',
    bookDeliveryLabel: 'Entrega:',
    bookStoreLabel: 'Loja',
    bookHomeLabel: 'Domicílio',
    bookAddressLabel: 'Morada:',
    bookSpecialNotes: 'Notas ou Pedidos Especiais (opcional)',
    bookSpecialNotesInfo: '💡 Esta informação será enviada à equipa junto com a sua reserva',
    bookSpecialNotesPlaceholder: 'Alguma informação adicional que queira partilhar? Ex: instruções de entrega, horário preferencial, etc.',
    // BookingModal - Backoffice payment
    bookPaymentMethodTitle: 'Método de Pagamento *',
    bookPaymentMethodDesc: 'Como o cliente irá pagar esta reserva?',
    bookPayInStore: 'Pagar em Loja',
    bookPayInStoreMark: 'Marcar como PAGO',
    bookSendLink: 'Enviar Link',
    bookAwaitingPaymentMsg: 'Reserva ficará AGUARDANDO PAGAMENTO. Um link de pagamento será enviado por SMS.',
    bookMarkedPaidMsg: 'Reserva será MARCADA COMO PAGA imediatamente.',
    bookPendingApprovalMsg: 'Reserva será enviada para aprovação. Receberá notificação por email e SMS.',
    bookDeliveryTimeLabel: 'Hora de entrega e recolha.',
    bookStoreTimesDesc: 'Pode haver uma taxa extra se o levantamento/devolução for fora do horário da loja.',
    // Layout / Sidebar
    loadingApp: 'A carregar...',
    logout: 'Sair',
    editMenu: 'Editar Menu',
    editMenuDesc: 'Clique para mostrar/ocultar items',
    softwareName: 'ORTHOCARE',
    // Reservations page
    resTitle: 'Reservas',
    resTitlePending: 'Reservas Pendentes',
    resLoading: 'A carregar...',
    resEmpty: 'Nenhuma reserva encontrada',
    resClearFilters: 'Limpar Filtros',
    resSearchPlaceholder: 'Pesquisar cliente ou equipamento...',
    resViewList: 'Lista',
    resViewCalendar: 'Calendário',
    resSort: 'Ordenar',
    resSortNext: '✓ Próximas',
    resStatusAll: 'Todos Estados',
    resStatusPending: 'Pendente',
    resStatusAwaiting: 'Aguarda Pag.',
    resStatusPaid: 'Pago',
    resStatusActive: 'Ativo',
    resStatusCompleted: 'Completo',
    resStatusCancelled: 'Cancelado',
    resMgmtAll: 'Todas Gestões',
    resMgmtPending: 'Pendente',
    resMgmtDelivered: 'Entregue',
    resMgmtCollected: 'Recolhida',
    resMgmtArchived: 'Arquivada',
    resOf: 'de',
    resExtensions: 'Prolongamento',
    resExtensionsPlural: 'Prolongamentos',
    resFilter: 'Filtrar',
    resReview: 'Rever',
    resSelectCustomer: '1. Selecionar Cliente',
    resSelectCustomerDesc: 'Escolha um cliente existente ou crie um novo',
    resSearchCustomer: 'Pesquisar cliente por nome, email ou telefone...',
    resNoCustomers: 'Nenhum cliente encontrado',
    resSelect: 'Selecionar',
    resCancel: 'Cancelar',
    resCreateCustomer: 'Criar Novo Cliente',
    resSelectEquipment: '2. Selecionar Equipamento',
    resSelectEquipmentDesc: 'Escolha o equipamento para a reserva',
    resSearchEquipment: 'Pesquisar equipamento por nome ou categoria...',
    resNoEquipment: 'Nenhum equipamento encontrado',
    resBack: 'Voltar',
    resDeleteConfirm: 'Confirmar Eliminação',
    resDeleteConfirmQ: 'Tem a certeza que deseja apagar esta reserva?',
    resDeleteWarning: '⚠️ Esta ação não pode ser desfeita!',
    resDeleteNo: 'Não, Cancelar',
    resDeleteYes: 'Sim, Apagar',
    resDeleting: 'A apagar...',
    resReviewExt: '⏳ Rever Prolongamento',
    resExtReject: '❌ Rejeitar',
    resExtApprove: '✅ Aprovar',
    resExtHistory: 'Histórico de Prolongamentos',
    resClose: 'Fechar',
    resPayTitle: 'Confirmar Pagamento da Reserva',
    resPayExtTitle: 'Confirmar Pagamento do Prolongamento',
  },
  en: {
    // Common
    phoneSupport: 'Phone Support',
    nationalLandline: 'Call to national landline',
    backoffice: 'Backoffice',
    customerArea: 'Customer Area',
    login: 'Login',
    services: 'Services',
    stores: 'Stores',
    contacts: 'Contacts',
    rental: 'Rental',
    onlineStore: 'Online Store',
    blog: 'Blog',
    aboutUs: 'About Us',
    book: 'Book',
    getStarted: 'Get Started',
    directions: 'Get Directions',
    allRights: 'All rights reserved.',
    learnMore: 'Learn More',
    callNow: 'Call Now',
    // Equipment
    exploreEquipment: 'Explore Equipment',
    featuredEquipment: 'Featured Equipment',
    exploreOur: 'Explore our',
    availableEquipment: 'Available Equipment',
    ceCertified: 'CE certified equipment with the highest quality on the market',
    viewAllEquipment: 'View All Equipment',
    swipeMore: 'Swipe to see more',
    priceFrom: 'From',
    priceDay: 'day',
    priceWeek: 'week',
    priceMonth: 'month',
    enquirePrice: 'Enquire price',
    // Fast delivery
    fastDelivery: 'Fast Delivery',
    deliveryH2: 'Equipment at Your',
    deliveryH2Highlight: 'Home in 2 Hours',
    deliveryDesc: 'With over 5 years of experience, we guarantee ultra-fast deliveries in the Lisbon District and throughout the country in 24-48h.',
    feature1: 'Assembly and disassembly included',
    feature2: 'Certified and sanitized equipment',
    feature3: 'Specialized technical team',
    feature4: '24/7 support available',
    // Stats
    satisfiedClients: 'Satisfied Clients',
    availableEquipmentStat: 'Available Equipment',
    yearsExperience: 'Years of Experience',
    supportAvailable: 'Support Available',
    // Services
    ourServices: 'Our Services',
    rentOrBuy: 'Rent or Buy?',
    twoSolutions: 'We offer two solutions so you can find the best option for your needs',
    // Rental card
    rentalTitle: 'Rental',
    rentalDesc: 'Ideal for temporary needs or to try before buying.',
    flexibility: 'Total Flexibility',
    flexibilityDesc: 'Rent by days, weeks or months',
    noCommitment: 'No Commitment',
    noCommitmentDesc: 'Return when you no longer need it',
    maintenanceIncluded: 'Maintenance Included',
    maintenanceIncludedDesc: 'Equipment always in perfect condition',
    fastDeliveryCard: 'Fast Delivery',
    fastDeliveryCardDesc: '24-48h nationwide. Lisbon same day',
    viewRental: 'View Equipment for Rent',
    // Buy card
    buyTitle: 'Buy',
    buyDesc: 'Perfect for prolonged or permanent use.',
    yoursForever: 'Yours Forever',
    yoursForeverDesc: 'Long-term investment',
    economical: 'More Economical',
    economicalDesc: 'For permanent needs',
    customization: 'Total Customization',
    customizationDesc: 'Adapt to your taste and needs',
    freeShipping: 'Free Shipping +',
    freeShippingDesc: 'Fast delivery nationwide',
    visitStore: 'Visit Online Store',
    // Comparison
    quickComparison: 'Quick Comparison',
    initialCost: 'Initial Cost',
    low: 'Low',
    higher: 'Higher',
    maintenanceRow: 'Maintenance',
    included: 'Included',
    yourAccount: 'Your responsibility',
    flexibilityRow: 'Flexibility',
    maximum: 'Maximum',
    committed: 'Committed',
    idealFor: 'Ideal for',
    rentalIdeal: 'Recovery, testing, short term',
    buyIdeal: 'Permanent use, chronic conditions',
    // Why choose us (Landing)
    whyChooseUs: 'Why Choose Us',
    yearsOfService: 'Over 5 Years at Your Service',
    feat1Title: 'Experience', feat1Desc: '+5 years on the market with CE certified equipment',
    feat2Title: 'Express Delivery', feat2Desc: '2 hours in the Lisbon District. 24-48h rest of country',
    feat3Title: 'Available 24h', feat3Desc: 'Phone and WhatsApp support at any time',
    feat4Title: 'Quality', feat4Desc: 'The best orthopedic and geriatric products',
    feat5Title: 'Support', feat5Desc: 'Specialized consultants always available',
    feat6Title: 'Urgent Deliveries', feat6Desc: 'Assembly and disassembly included',
    feat7Title: 'Stock', feat7Desc: 'Large showroom for immediate delivery',
    feat8Title: 'Trust', feat8Desc: 'Hundreds of satisfied clients',
    // Testimonials
    testimonials: 'Testimonials',
    whatClientsSay: 'What Our',
    clientsLabel: 'Clients Say',
    clientSince: 'Client since',
    testimonial1: 'Excellent service! Delivery was fast and the equipment was impeccable. Highly recommend!',
    testimonial2: 'Very attentive professionals and superior quality equipment. Will definitely return.',
    testimonial3: '24h support made all the difference. I needed urgent help and they were incredible!',
    // Stores
    ourStores: 'Our Stores',
    visitUsLisbon: 'Visit Us in Lisbon',
    twoStoresDesc: 'Two stores at your disposal with specialized professionals',
    // CTA
    readyToStart: 'Ready to Start?',
    exploreOrVisit: 'Explore our equipment or visit our online store',
    viewRentalCTA: 'View Equipment for Rent',
    buyOnline: 'Buy at Online Store',
    // FAQ
    faqBadge: 'Frequently Asked Questions',
    faqTitle: 'Clear Your',
    faqTitleHighlight: 'Doubts',
    faqDesc: 'Answers to the most common questions about our services',
    // Quote
    quoteBadge: 'Quote Request',
    quoteTitle: 'Request a',
    quoteTitleHighlight: 'Personalized Quote',
    quoteDesc: 'Fill in the form and receive a proposal tailored to your needs',
    // Contact bar
    support24h: '24-Hour Support',
    available24hDesc: 'We are available at any hour of the day or night',
    phone24h: 'Phone 24h',
    whatsapp24h: 'WhatsApp 24h',
    messageLabel: 'Message',
    // Reservas page
    rentalEquipment: 'Equipment for Rental',
    loadingEquipment: 'Loading equipment...',
    noEquipmentFound: 'No equipment found.',
    availableBadge: 'Available',
    allCategories: 'All',
    perDay: 'Per Day:',
    perWeek: 'Per Week:',
    perMonth: 'Per Month:',
    bookNow: 'Book Now',
    simulate: 'Simulate',
    details: 'Details',
    seeAll: 'View All Equipment',
    contactCenter: 'Support Center',
    hours24: '24 hours',
    // Features Reservas
    moreExperience: 'More Experience',
    moreExperienceDesc: 'We have been in the market for over 5 years, with CE certified equipment.',
    fastDeliveries: 'Fast Deliveries',
    fastDeliveriesDesc: 'We deliver in 24-48h nationwide. In Lisbon, same-day deliveries.',
    highQuality: 'High Quality',
    highQualityDesc: 'We select the best orthopedic and geriatric products.',
    professionalSupport: 'Professional Support',
    professionalSupportDesc: 'Specialized consultants to help find the best solution.',
    ownTechTeam: 'Own Technical Team',
    ownTechTeamDesc: 'Transport, assembly and equipment maintenance team.',
    faster: 'Faster',
    fasterDesc: 'Same-day or under 24-hour deliveries.',
    freeDemo: 'Free Demonstrations',
    freeDemoDesc: 'Home demonstrations of electric wheelchairs and scooters.',
    largestStock: 'Largest Stock',
    largestStockDesc: 'Large showroom of products for immediate delivery.',
    whyChooseTitle: 'Care with Experience',
    whyChooseSubtitle: 'Over 5 years dedicated to your well-being',
    // Reviews
    whatClientsSayReservas: 'What Our Clients',
    sayAboutUs: 'Say About Us',
    // Contact Reservas
    talkToUs: 'Talk to Us',
    contactUsTitle: 'Contact Us',
    hereToHelp: 'We are here to help! Send us your message and we will respond quickly.',
    phoneLabel: 'Phone',
    scheduleLabel: 'Schedule',
    usefulLinks: 'Useful Links',
    equipment: 'Equipment',
    customerAreaFooter: 'Customer Area',
    loginRegister: 'Login / Register',
    completeProfile: 'Complete Your Profile',
    completeProfileDesc: 'Please complete your details before making a reservation.',
    // AboutUs
    ourValuesTitle: 'Our Values',
    ourValuesPrinciples: 'Principles that guide every decision and interaction with our clients.',
    ourJourney: 'Our Journey',
    ourTeam: 'Our Team',
    dedicatedPros: 'Professionals dedicated to your well-being',
    visitUsTitle: 'Visit Us',
    careTitle: 'Care and Empathy',
    careDesc: 'We treat each client like family, understanding their unique mobility and well-being needs.',
    qualityGuaranteedTitle: 'Guaranteed Quality',
    qualityGuaranteedDesc: 'All our equipment is CE certified and goes through rigorous maintenance and sanitization processes.',
    quickResponseTitle: 'Quick Response',
    quickResponseDesc: 'We deliver in 24-48 hours because we know mobility cannot wait.',
    commitmentTitle: 'Total Commitment',
    commitmentDesc: 'We accompany our clients from equipment selection to return.',
    salesTeam: 'Sales Team',
    salesRole: 'Customer Service',
    salesDesc: 'Specialists in helping find the ideal equipment for each situation.',
    techTeam: 'Technical Team',
    techRole: 'Maintenance & Logistics',
    techDesc: 'Responsible for the preparation, delivery and collection of all equipment.',
    supportTeam: 'Support Team',
    supportRole: 'Support 24/7',
    supportDesc: 'Available to resolve any question at any time.',
    ctaTitle: 'Ready to Start?',
    ctaDesc: 'Explore our equipment for rental or visit our online store.',
    viewRentalAbout: 'View Equipment for Rental',
    visitOnlineStore: 'Visit Online Store',
    // Reservas hardcoded
    rentWord: 'Rent',
    equipmentWord: 'Equipment',
    rentCardDesc: 'Wheelchairs, articulated beds, walkers and much more.',
    buyWord: 'Buy',
    productsWord: 'Products',
    buyCardDesc: 'Visit our online store or place your order.',
    viewStoreBtn: 'View Store',
    openingHours: 'Mon-Fri: 09:30-13h / 14h-18:30 | Sat: 09h-13h',
    openingHoursJunqueira: 'Mon-Fri: 09:30-13h / 14h-18:30',
    heroBodyText: 'Quality orthopedic equipment to <strong>rent</strong> or <strong>buy</strong>.<br/><strong>24-hour support</strong> by phone and WhatsApp. <strong>2-hour deliveries</strong> in the Lisbon District.',
    lojaBenfica: 'Benfica Store',
    lojaJunqueira: 'Junqueira Store',
    storeNameBenfica: 'Benfica Store',
    storeNameJunqueira: 'Junqueira Store',
    getStartedNow: 'Get Started',
    // FAQ
    faqMainTitle: 'Frequently Asked',
    faqMainHighlight: 'Questions',
    faqMainDesc: 'Everything you need to know about orthopedic equipment rental in Portugal',
    faqNoAnswer: 'Didn\'t find the answer you were looking for?',
    faqCallNow: 'Call Now: 21 603 5281',
    faqSendEmail: 'Send Email',
    faqQ1: 'How does orthopedic equipment rental work?',
    faqA1: 'The process is simple and fast: 1) Choose the equipment you need from our online catalog, 2) Select the rental period (day, week or month), 3) Book online securely, 4) Receive certified and sanitized equipment at home. We deliver throughout Portugal in 24-48h.',
    faqQ2: 'How much does it cost to rent a wheelchair in Portugal?',
    faqA2: 'Prices vary depending on the type of wheelchair and the chosen period. Manual wheelchairs start at very affordable daily rates, with significant discounts for longer periods. Check our catalog for specific prices. All prices include certified, sanitized equipment with guaranteed maintenance.',
    faqQ3: 'Do you deliver throughout Portugal?',
    faqA3: 'Yes, we deliver throughout the national territory! We serve Lisbon, Porto, Coimbra, Braga, Faro and all other cities. Delivery is fast (24-48h) and includes installation and usage instructions. We also collect at the end of the rental period.',
    faqQ4: 'Is the orthopedic equipment certified and safe?',
    faqA4: 'Yes, 100%! All our equipment is certified according to European quality and safety standards. Each item is professionally sanitized and disinfected between uses, following strict hospital protocols. We perform regular preventive maintenance on all equipment.',
    faqQ5: 'Can I extend the rental period?',
    faqA5: 'Yes, you can extend the rental at any time! Just contact us by phone, email or through your customer area before the end of the initial period. We offer total flexibility to adapt to your recovery.',
    faqQ6: 'What types of orthopedic equipment do you have available?',
    faqA6: 'We have: manual and electric wheelchairs, electric and manual articulated beds, walkers, crutches, shower chairs, transfer lifts, access ramps, anti-bedsore cushions, orthopedic mattresses, and much more.',
    faqQ7: 'Is a deposit required for rental?',
    faqA7: 'It depends on the type of equipment. Some higher-value products require a security deposit, fully refunded at the end of the rental if the equipment is returned in good condition. We always inform you of the deposit amount before confirming the reservation.',
    faqQ8: 'How is the return of the equipment handled?',
    faqA8: 'Return is very simple! We collect the equipment directly from your address, or you can return it to one of our stores. We schedule the collection date and time in advance. You don\'t need to pack anything - we take care of everything.',
    faqQ9: 'Do you provide training on how to use the equipment?',
    faqA9: 'Yes, absolutely! At delivery, our specialized technician gives a complete demonstration, answers all your questions and leaves written instructions. We also provide continuous phone support throughout the entire rental period.',
    faqQ10: 'Can I rent equipment for a family member or friend?',
    faqA10: 'Yes, you can rent in someone else\'s name! Just indicate the person\'s details and delivery address during the reservation process. We facilitate the entire process so you can help those in need.',
    faqQ11: 'How long does equipment delivery take?',
    faqA11: 'For Greater Lisbon and Greater Porto, we can deliver the same day or the next day. For the rest of mainland Portugal, delivery is normally made within 24-48h after payment confirmation. For urgent situations, contact us.',
    faqQ12: 'What payment methods do you accept?',
    faqA12: 'We accept: credit/debit card (Visa, Mastercard), Multibanco, MBWay, and bank transfer. Payment is fully secure. For long-term rentals, we also offer installment payment options.',
    faqCatProcess: 'Process',
    faqCatPrices: 'Prices',
    faqCatDelivery: 'Deliveries',
    faqCatQuality: 'Quality',
    faqCatFlex: 'Flexibility',
    faqCatCatalog: 'Catalog',
    faqCatPayment: 'Payment',
    faqCatReturn: 'Return',
    faqCatSupport: 'Support',
    // ContactForm
    contactFormTitle: 'Send Us a Message',
    contactFormSubtitle: 'Fill in the form and we will contact you within the next 24 hours',
    contactFormNameLabel: 'Full Name',
    contactFormEmailLabel: 'Email',
    contactFormPhoneLabel: 'Phone',
    contactFormMessageLabel: 'Message',
    contactFormNamePlaceholder: 'Ex: John Smith',
    contactFormEmailPlaceholder: 'Ex: john.smith@email.com',
    contactFormPhonePlaceholder: 'Ex: 912345678',
    contactFormMessagePlaceholder: 'Describe what you need: equipment type, rental period, location, etc.',
    contactFormSending: 'Sending...',
    contactFormSendBtn: 'Send Message',
    contactFormSuccessTitle: 'Message Sent Successfully!',
    contactFormSuccessDesc: 'We received your message and will reply shortly.',
    contactFormSuccessEmail: 'We also sent a confirmation email to',
    contactFormNewMsg: 'Send New Message',
    contactFormRequired: '* Required fields. Your data will be treated confidentially.',
    contactFormErrorSend: 'Error sending message. Please try again or contact us directly.',
    contactFormErrNameReq: 'Name is required',
    contactFormErrNameMin: 'Name must be at least 3 characters',
    contactFormErrEmailReq: 'Email is required',
    contactFormErrEmailInvalid: 'Invalid email',
    contactFormErrPhoneReq: 'Phone is required',
    contactFormErrPhoneInvalid: 'Invalid phone (ex: 912345678 or +351912345678)',
    contactFormErrMsgReq: 'Message is required',
    contactFormErrMsgMin: 'Message must be at least 10 characters',
    // QuoteRequestForm
    quoteFormNameLabel: 'Full Name',
    quoteFormPhoneLabel: 'Phone',
    quoteFormEmailLabel: 'Email',
    quoteFormEquipmentLabel: 'Desired Equipment',
    quoteFormMsgLabel: 'Message / Request Details',
    quoteFormEquipmentPlaceholder: 'Ex: Wheelchair, Scooter...',
    quoteFormMsgPlaceholder: 'Describe your needs, desired period, location, etc.',
    quoteFormSending: 'Sending...',
    quoteFormSubmit: 'Request Free Quote',
    quoteFormSuccessTitle: 'Request Sent Successfully!',
    quoteFormSuccessDesc: 'We will contact you shortly with your personalized quote.',
    quoteFormSendAnother: 'Send Another Request',
    quoteFormFooter: 'We will respond within 24 hours. Personalized service guaranteed.',
    quoteFormNamePlaceholder: 'Your name',
    // Reservas page settings defaults
    reservasHeroTitle: 'Orthopedic Equipment Rental',
    reservasHeroSubtitle: 'Quality orthopedic equipment for rental. Home delivery throughout the country.',
    reservasHeroButton: 'View Equipment',
    reservasWelcomeTitle: 'Welcome to',
    reservasWelcomeText: 'We are the brand that cares. Here, you will find everything you need to improve your quality of life or that of those you love. From mobility aids and support products to specialized services, we are by your side to offer personalized and innovative solutions that promote comfort and safety.',
    landingHeroSubtitle: 'Your Trusted Orthopedics in Lisbon',
    // Blog
    blogRental: 'Rental',
    blogStore: 'Store',
    blogAboutUs: 'About Us',
    blogHeroDesc: 'Tips, news and information about mobility and orthopedic equipment.',
    blogSearchPlaceholder: 'Search articles...',
    blogAll: 'All',
    blogLoading: 'Loading articles...',
    blogEmpty: 'No articles found.',
    blogReadArticle: 'Read Article',
    blogReadMore: 'Read more',
    blogNewsletterTitle: 'Stay Informed',
    blogNewsletterDesc: 'Visit our blog regularly for more tips and news about mobility.',
    blogViewEquipment: 'View Equipment',
    blogVisitStore: 'Visit Store',
    // Reviews
    reviewsTitle: 'What Our',
    reviewsHighlight: 'Clients Say',
    reviewsSubtitle: 'Verified reviews from clients in Portugal',
    reviewsLeaveBtn: 'Leave a Review',
    reviewsCancel: 'Cancel',
    reviewsVerified: 'Verified Client',
    reviewsFormTitle: 'Leave Your Review',
    reviewsFormName: 'Name',
    reviewsFormNamePlaceholder: 'Your name',
    reviewsFormEquipment: 'Rented Equipment',
    reviewsFormEquipmentPlaceholder: 'Ex: Manual Wheelchair',
    reviewsFormRating: 'Rating',
    reviewsFormComment: 'Comment',
    reviewsFormCommentPlaceholder: 'Share your experience with orthopedic equipment rental...',
    reviewsFormSubmit: 'Publish Review',
    reviewsBasedOn: 'Based on',
    reviewsReview: 'review',
    reviewsReviews: 'reviews',
    // RentalSimulator
    simTitle: 'Rental Simulator',
    simDesc: 'Simulate the rental cost of',
    simStep1: 'Simulation',
    simStep2: 'Contact',
    simCountyLabel: 'Delivery County',
    simCountyPlaceholder: 'Select county',
    simRentalMode: 'Rental Mode *',
    simPerDay: 'Per Day',
    simPerWeek: 'Per Week',
    simPerMonth: 'Per Month',
    simStartDate: 'Start Date *',
    simEndDate: 'End Date *',
    simDeliverySchedule: 'Delivery and Collection Schedule',
    simDeliveryTime: 'Delivery Time',
    simPickupTime: 'Collection Time',
    simExtraFeeWarning: 'Deliveries/collections outside these hours or on weekends have an extra fee',
    simDeliveryType: 'Delivery Type *',
    simStorePickup: 'Store Pickup',
    simHomeDelivery: 'Home Delivery',
    simOptionalExtras: 'Optional Extras',
    simCostSummary: 'Cost Summary',
    simRentalLabel: 'Rental',
    simPrep: 'Preparation',
    simDeliveryFee: 'Delivery Fee',
    simPickupFee: 'Collection Fee',
    simExtrasLabel: 'Extras',
    simExtraFees: 'Extra Fees',
    simSubtotal: 'Subtotal',
    simDeposit: '+ Deposit (refundable)',
    simTotal: 'TOTAL',
    simDepositNote: 'The deposit will be fully refunded after return of equipment in good condition.',
    simSendMethod: 'Send Method *',
    simFullName: 'Full Name *',
    simPhone: 'Phone / WhatsApp *',
    simEmail: 'Email *',
    simOptMsg: 'Additional Message (Optional)',
    simMsgPlaceholder: 'Leave a message or special request here...',
    simBack: 'Back',
    simCancel: 'Cancel',
    simContinue: 'Continue',
    simSending: 'Sending...',
    simSendProposal: 'Send Proposal',
    simProposalSent: '✅ Proposal Sent!',
    simProposalDesc: 'You will receive the professional proposal shortly',
    simProposalTeam: 'Our team will contact you to confirm availability.',
    simSimComplete: 'Simulation complete! Choose how you want to receive the professional proposal.',
    simDays: 'days',
    simNote: 'Note',
    simWarning: 'This is just a simulation. The booking will only be confirmed after contact from our team and availability check.',
    simEmailBy: 'by email',
    simSmsBY: 'by SMS',
    simWhatsappBy: 'on WhatsApp',
    simWorkHours: 'Hours',
    simWorkDays: '(Mon-Fri)',
    // BookingModal
    bookTitle: 'New Booking',
    bookCompleteProfile: 'Complete Your Profile',
    bookStep1: 'Dates & Extras',
    bookStep2: 'Delivery',
    bookStep3: 'Confirm',
    bookRentalMode: '1. Rental Mode *',
    bookSelectMode: 'Select mode first',
    bookPerDay: 'Per Day',
    bookPerWeek: 'Per Week',
    bookPerMonth: 'Per Month',
    bookStartDate: '2. Start Date *',
    bookEndDate: '3. End Date *',
    bookCancel: 'Cancel',
    bookContinue: 'Continue',
    bookBack: 'Back',
    bookConfirm: 'Confirm Booking',
    bookCreate: 'Create Booking',
    bookProcessing: 'Processing...',
    bookSaving: 'Saving...',
    bookSaveAndContinue: 'Save and Continue',
    bookDeliveryType: 'Delivery Type *',
    bookStorePickup: 'Store',
    bookStorePickupSub: 'Pickup',
    bookHomeDelivery: 'Home',
    bookHomeDeliverySub: 'Delivery',
    bookReservationSummary: 'Booking Summary',
    bookViewAvailability: '📅 View Availability',
    bookCalendarDesc: 'Visual calendar of available dates',
    bookShow: 'Show',
    bookHide: 'Hide',
    bookMode: 'Mode',
    bookModeDaily: 'Daily',
    bookModeWeekly: 'Weekly',
    bookModeMonthly: 'Monthly',
    bookTotal: 'Total',
    bookEdit: 'Edit',
    bookIncompleteProfile: 'Incomplete Profile',
    bookIncompleteDesc: 'Please complete your profile before making a reservation.',
    bookMissingFields: 'Missing fields',
    // BookingModal - Profile form
    bookPersonalData: 'Required Personal Data',
    bookFullName: 'Full Name *',
    bookPhoneField: 'Phone *',
    bookEmailField: 'Email *',
    bookEmailNote: 'Email cannot be changed',
    bookFullAddress: 'Full Address *',
    bookDoorNumber: 'Door Number *',
    bookFloor: 'Floor (optional)',
    bookPostalCode: 'Postal Code *',
    bookLocality: 'Locality *',
    bookCountyField: 'County *',
    bookNIF: 'NIF (optional)',
    bookCC: 'ID Card (optional)',
    // BookingModal - Step 2
    bookSelectStore: 'Select Store *',
    bookNoStores: 'No stores available',
    bookPickupReturnTimes: 'Pickup/Return Times',
    bookDeliveryReturnTimes: 'Delivery/Collection Times',
    bookOutsideHoursFee: 'Choosing hours outside store hours may incur an extra fee',
    bookPickupHour: 'Pickup Time',
    bookReturnHour: 'Return Time',
    bookDeliveryHour: 'Delivery',
    bookPickupHourLabel: 'Collection',
    bookDeliveryAddressLabel: 'Delivery Address',
    bookProfileAddress: 'Profile address',
    bookDifferentAddress: 'Different address',
    bookProfileAddressTitle: 'Profile Address',
    // BookingModal - Step 3 summary
    bookEquipmentLabel: 'Equipment:',
    bookPeriodLabel: 'Period:',
    bookDeliveryLabel: 'Delivery:',
    bookStoreLabel: 'Store',
    bookHomeLabel: 'Home',
    bookAddressLabel: 'Address:',
    bookSpecialNotes: 'Special Notes or Requests (optional)',
    bookSpecialNotesInfo: '💡 This information will be sent to our team along with your reservation',
    bookSpecialNotesPlaceholder: 'Any additional information? E.g.: delivery instructions, preferred time, etc.',
    // BookingModal - Backoffice payment
    bookPaymentMethodTitle: 'Payment Method *',
    bookPaymentMethodDesc: 'How will the client pay for this reservation?',
    bookPayInStore: 'Pay in Store',
    bookPayInStoreMark: 'Mark as PAID',
    bookSendLink: 'Send Link',
    bookAwaitingPaymentMsg: 'Reservation will be AWAITING PAYMENT. A payment link will be sent by SMS.',
    bookMarkedPaidMsg: 'Reservation will be MARKED AS PAID immediately.',
    bookPendingApprovalMsg: 'Reservation will be sent for approval. You will receive notification by email and SMS.',
    bookDeliveryTimeLabel: 'Delivery and collection times.',
    bookStoreTimesDesc: 'An extra fee may apply if pickup/return is outside store hours.',
    // Layout / Sidebar
    loadingApp: 'Loading...',
    logout: 'Logout',
    editMenu: 'Edit Menu',
    editMenuDesc: 'Click to show/hide items',
    softwareName: 'ORTHOCARE',
    // Reservations page
    resTitle: 'Reservations',
    resTitlePending: 'Pending Reservations',
    resLoading: 'Loading...',
    resEmpty: 'No reservations found',
    resClearFilters: 'Clear Filters',
    resSearchPlaceholder: 'Search customer or equipment...',
    resViewList: 'List',
    resViewCalendar: 'Calendar',
    resSort: 'Sort',
    resSortNext: '✓ Upcoming',
    resStatusAll: 'All Status',
    resStatusPending: 'Pending',
    resStatusAwaiting: 'Awaiting Pay',
    resStatusPaid: 'Paid',
    resStatusActive: 'Active',
    resStatusCompleted: 'Completed',
    resStatusCancelled: 'Cancelled',
    resMgmtAll: 'All Management',
    resMgmtPending: 'Pending',
    resMgmtDelivered: 'Delivered',
    resMgmtCollected: 'Collected',
    resMgmtArchived: 'Archived',
    resOf: 'of',
    resExtensions: 'Extension',
    resExtensionsPlural: 'Extensions',
    resFilter: 'Filter',
    resReview: 'Review',
    resSelectCustomer: '1. Select Customer',
    resSelectCustomerDesc: 'Choose an existing customer or create a new one',
    resSearchCustomer: 'Search customer by name, email or phone...',
    resNoCustomers: 'No customers found',
    resSelect: 'Select',
    resCancel: 'Cancel',
    resCreateCustomer: 'Create New Customer',
    resSelectEquipment: '2. Select Equipment',
    resSelectEquipmentDesc: 'Choose the equipment for the reservation',
    resSearchEquipment: 'Search equipment by name or category...',
    resNoEquipment: 'No equipment found',
    resBack: 'Back',
    resDeleteConfirm: 'Confirm Deletion',
    resDeleteConfirmQ: 'Are you sure you want to delete this reservation?',
    resDeleteWarning: '⚠️ This action cannot be undone!',
    resDeleteNo: 'No, Cancel',
    resDeleteYes: 'Yes, Delete',
    resDeleting: 'Deleting...',
    resReviewExt: '⏳ Review Extension',
    resExtReject: '❌ Reject',
    resExtApprove: '✅ Approve',
    resExtHistory: 'Extension History',
    resClose: 'Close',
    resPayTitle: 'Confirm Reservation Payment',
    resPayExtTitle: 'Confirm Extension Payment',
  }
};